import { type IReportSurveySection } from '../../../models/Report'

export interface ReportInsightsLoadingSection {
  id: string
  showInstructorLine: boolean
}

export const REPORT_INSIGHTS_FALLBACK_CARD_COUNT = 4

export const createFallbackReportInsightsLoadingSections = (
  count: number = REPORT_INSIGHTS_FALLBACK_CARD_COUNT
): ReportInsightsLoadingSection[] => {
  return Array.from({ length: count }, (_, index) => ({
    id: `fallback-report-loading-section-${index}`,
    showInstructorLine: false
  }))
}

export const buildLoadingSectionsFromBaseReport = (
  surveySections: IReportSurveySection[] | null | undefined
): ReportInsightsLoadingSection[] | null => {
  if (!surveySections?.length) {
    return null
  }

  return surveySections.map((section, sectionIndex) => ({
    id: `${section.surveySectionId ?? `base-report-section-${sectionIndex}`}-${sectionIndex}`,
    showInstructorLine: Boolean(section.isRepeatPerInstructor)
  }))
}

export const resolveReportInsightsLoadingSections = (
  baseReportLoadingSections: ReportInsightsLoadingSection[] | null | undefined
): ReportInsightsLoadingSection[] => {
  if (baseReportLoadingSections?.length) {
    return baseReportLoadingSections
  }

  // If the base report shape has not loaded yet, keep the skeleton generic
  // rather than reaching into template APIs the current reports user may not access.
  return createFallbackReportInsightsLoadingSections()
}
